import React, { useEffect, useState } from "react";
import MainBg from "../components/Mainbg";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_TRACK_MENU } from "../config/ApisCollection";
import { useDispatch } from "react-redux";
import trackloader from "../assets/images/loaders/trackloader.png";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";

const tractmenulink = {
  fasting: {
    url: "/track/fasting",
  },
  workout: {
    url: "/track/workout",
  },
  calories: {
    url: "/track/calorie",
  },
  water: {
    url: "/track/water",
  },
  health: {
    url: "/track/health",
  },
};

const TrackMenu = () => {
  const [menuItemdata, setMenuItemData] = useState(null);
  const [deviceData, setDeviceData] = useState(null);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const dispatch = useDispatch();
  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };

  const GetTrackMenu = async () => {
    // const request_body = {};
    const request_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.get(GET_TRACK_MENU, request_header);
      if (response.data) {
        setTimeout(() => {
          setDeviceData(response.data.data.device);
          setMenuItemData(response.data.data.track);
        }, 2000);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    GetTrackMenu();
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainBg>
      <div className="container lg:w-5/12 sm:w-1/2 w-full m-auto">
        {deviceData ? (
          <div className="flex flex-row justify-center gap-2 mt-10">
            <div className="cardbox w-full sm:w-full md:w-full lg:w-full xl:w-full xs:w-full ">
              <div className="mode1">
                <img
                  className="watchImg"
                  alt="watchImg"
                  src={deviceData.backgroundimg}
                />
                <div className="py-2">
                  <p className="cardboxtitle text-base">
                    {deviceData.headline}
                  </p>
                  <p className="text-xs"> {deviceData.title}</p>
                  <button
                    className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                    onClick={() => {
                      handleChangeSidebar(311);
                    }}
                  >
                    {deviceData.buttonName}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <img src={trackloader} className="h-72 m-auto" />
            <h1 className="text-center mt-10">loading....</h1>
          </>
        )}

        {/* menu items  */}
        {menuItemdata ? (
          <div className="mt-10">
            <h1 className="text-xl font-bold mt-10">{menuItemdata.headline}</h1>
            <p className="text-[#333]">{menuItemdata.title}</p>
          </div>
        ) : (
          <></>
        )}
        <div className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-2 grid-cols-2 justify-center gap-5 mt-3">
          {menuItemdata?.tracklist?.map((items, index) => {
            return (
              <Link
                to={tractmenulink[items.categorykey]?.url}
                className="cardbox w-full sm:w-full md:w-full lg:w-full xl:w-full xs:w-1/2 p-2 cursor-pointer"
                key={index}
              >
                <div>
                  <div className="">
                    <img
                      className="h-[48px] w-[48px] m-auto"
                      alt="watchImg"
                      src={items.image}
                    />
                    <p className="text-sm font-bold text-center mt-2">
                      {items.categoryvalue}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </MainBg>
  );
};

export default React.memo(TrackMenu);
